import React, { useRef, useState, useContext } from 'react'
import classes from './ScheduleAlertBtn.module.css'
import { Dropdown, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import Flatpickr from "react-flatpickr";
import { useSelector } from 'react-redux'
import { insertOneMe } from '../../../axios/requests/notificationsReq'
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'

const ScheduleAlertBtn = (props) => {
    const [t] = useTranslation('common')
    const FlatpickrRef = useRef()
    const reasonInputRef = useRef()
    const alertCtx = useContext(AlertContext)
    const [flatpickrValue, setFlatpickrValue] = useState(new Date())
    const [showDropDown, setShowDropDown] = useState(false)
    const selectedConv = useSelector(state => state.msgs.selectedConv)

    const dateSelectedHandler = (date) => {
        setFlatpickrValue(date)
    }

    const submitHandler = () => {
        const reasonValue = (reasonInputRef.current.value).trim()
        if (reasonValue.length >= 128) {
            return alertCtx.showAlert(t('error'), t('The reason must contain up to 128 characters'), 'sm')
        }
        const addNotificationObj = {
            clientName: selectedConv.clientName,
            msgType: selectedConv.msgType,
            notificationType: "channel",
            reason: reasonInputRef.current.value,
            notificationTime: flatpickrValue,
            relatedChat: selectedConv._id,
            channelId: selectedConv.channelId
        }
        // console.log(addNotificationObj)
        reasonInputRef.current.value = ''
        changeDropDownShowHandler(false)
        insertOneMe(addNotificationObj).then(res => {
            alertCtx.showAlert(t('success'), t('The alert was added successfully'), 'sm')
        }).catch(e => {
            alertCtx.showAlert(t('error'), t('Error adding alert'), 'sm')
        })
    }

    const changeDropDownShowHandler = (nextShow) => {
        setShowDropDown(nextShow)
    }

    return (
        <Dropdown show={showDropDown} onToggle={changeDropDownShowHandler}>
            <Dropdown.Toggle className={`${classes['notification-alert']}`}>
                {props.children}
            </Dropdown.Toggle>
            <Dropdown.Menu className={`${classes.CustomMenu}`}>
                <form className={`${classes['formStyle']}`}>
                    <div className={`${classes['time-selecter-box']}`}>
                        <Flatpickr id="notification-time-picker" options={{ time_24hr: true, static: true }} ref={FlatpickrRef} className={classes['time-picker']} data-enable-time value={flatpickrValue} onChange={dateSelectedHandler} />
                        <label htmlFor='notification-time-picker' className={classes['time-label']}>{t('time')}</label>
                    </div>
                    <div className={`${classes['reason-box']}`}>
                        <label htmlFor="notification-reason-textarea" className={classes['reason-label']}>{t('reason')}</label>
                        <textarea id="notification-reason-textarea" ref={reasonInputRef} className={classes['reason-input']} />
                    </div>

                    <div className={classes['btn-actions']}>
                        <Button onClick={submitHandler} className={classes['action-btn']} variant="success">{t('confirm')}</Button>
                        <Button className={classes['action-btn']} onClick={() => changeDropDownShowHandler(false)} variant="secondary">{t('cancel')}</Button>
                    </div>
                </form>
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default ScheduleAlertBtn